import {
  PromotionUxSignalProduct,
  PromotionUxSignalResponse,
  PromotionUxSignalResponseSchema,
} from '~/schemas/promotionUxSignal'
import { nextApiClient } from './clients/nextApiClient'

export const getPromotionUxSignal = async (
  product?: PromotionUxSignalProduct
): Promise<PromotionUxSignalResponse> => {
  const { data } = await nextApiClient.post('/promotions/uxsignal', undefined, {
    params: product ? { product } : undefined,
  })

  return PromotionUxSignalResponseSchema.parse(data)
}
